module.exports = __webpack_public_path__ + "static/48-6324e8b4286a0ebf18ae4e77fd7610db.png";